import {useId} from 'react';
import type {UseFormReturn} from 'react-hook-form';
import {useWatch} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {Checkbox} from '@/components/ui/checkbox';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {InputLabel} from '@/components/ui/input';
import {Textarea} from '@/components/ui/textarea';

import type {TaskActionFormValues} from '../../utils/tasksFormInputs';

type TaskActionFormFieldsProps = {
  form: UseFormReturn<TaskActionFormValues>;
};

function TaskActionFormFields({form}: TaskActionFormFieldsProps) {
  const {t} = useTranslation();
  const commentId = useId();
  const rejectId = useId();
  const mode = useWatch({control: form.control, name: 'mode'});

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <Checkbox
            id={commentId}
            checked={mode === 'comment'}
            onCheckedChange={checked => {
              form.setValue('mode', checked ? 'comment' : 'none');
              form.clearErrors('comment');
            }}
          />
          <InputLabel htmlFor={commentId}>
            {t('Complete with comment')}
          </InputLabel>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox
            id={rejectId}
            checked={mode === 'reject'}
            onCheckedChange={checked => {
              form.setValue('mode', checked ? 'reject' : 'none');
              form.clearErrors('rejectionNote');
            }}
          />
          <InputLabel htmlFor={rejectId} className="text-red-600">
            {t('Reject task')}
          </InputLabel>
        </div>
      </div>
      {mode === 'comment' && (
        <FormField
          control={form.control}
          name="comment"
          render={({field}) => (
            <FormItem>
              <FormLabel required>{t('Comment')}</FormLabel>
              <FormControl>
                <Textarea {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
      {mode === 'reject' && (
        <FormField
          control={form.control}
          name="rejectionNote"
          render={({field}) => (
            <FormItem>
              <FormLabel required>{t('Rejection note')}</FormLabel>
              <FormControl>
                <Textarea {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
}

export default TaskActionFormFields;
